// extracted by mini-css-extract-plugin
module.exports = {"fieldWrapper":"entryDetailStyles_fieldWrapper__meT4i","entryDetailLabel":"entryDetailStyles_entryDetailLabel__1FJiw"};